var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Production-Foreman',{attrs:{"foreman-type":"asphalt","supplier":_vm.supplier,"mix-design":_vm.mixDesign}})
}
var staticRenderFns = []

export { render, staticRenderFns }